import { useErrorBoundary } from 'react-error-boundary';
import { Button } from '@shared/ui/Button/Button.js';

export function RouteErrorFallback() {
  const { resetBoundary } = useErrorBoundary();

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center">
      <p className="text-4xl mb-4" aria-hidden="true">💥</p>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">Algo salió mal</h2>
      <p className="text-gray-500 mb-6">
        Esta página encontró un error inesperado.
      </p>
      <Button variant="secondary" onClick={resetBoundary}>
        Reintentar
      </Button>
    </div>
  );
}
